function isInUsersListPage() {
  return $("#userslist-page").length > 0;
}

if (isInUsersListPage()) {

  $("input#startAuditDate:enabled").datepicker({
    showOn: "both",
    buttonImageOnly: false,
    buttonText: "Select date",
    dateFormat: "dd/mm/yy",
    selectOtherMonths: true,
    //            minDate: paymentValidationDate,

    beforeShow: function (dateText, obj) {
      setTimeout(function () {

        $("#download-detailed-report").append($("#ui-datepicker-div"));

        $("#ui-datepicker-div").css("top", "107px");
        $("#ui-datepicker-div").css("left", "460px");
        $("#ui-datepicker-div").css("display", "block");
        $("#ui-datepicker-div").css("opacity", "1");
        //                        var validationDate = $('#paymentValidationDate').val();
        //                        validationDate = "20/08/2020";
        //                        paymentValidationDate = validationDate;
        //                        $('#receiptDate').datepicker('option', 'minDate', validationDate);
      }, 0);
    },
    onClose: function (dateText, obj) {
      $("#download-detailed-report #ui-datepicker-div").css("opacity", "0");
      $("#download-detailed-report #ui-datepicker-div").css("display", "none");
      $("body").append($("#ui-datepicker-div"));
    },
  });
  $("input#endAuditDate:enabled").datepicker({
    showOn: "both",
    buttonImageOnly: false,
    buttonText: "Select date",
    dateFormat: "dd/mm/yy",
    //            minDate: receiptValidationDate,
    beforeShow: function (dateText, obj) {
      setTimeout(function () {

        $("#download-detailed-report").append($("#ui-datepicker-div"));

        $("#ui-datepicker-div").css("top", "107px");
        $("#ui-datepicker-div").css("left", "460px");
        $("#ui-datepicker-div").css("display", "block");
        $("#ui-datepicker-div").css("opacity", "1");
        //                        var validationDate = $('#receiptValidationDate').val();
        //                        validationDate = "25/08/2020";
        //                        $('#paymentDate').datepicker('option', 'minDate', validationDate);
        //                        receiptValidationDate = validationDate;
        //                    }
      }, 0);
    },
    onClose: function () {
      $("dialog #ui-datepicker-div").css("opacity", "0");
      $("dialog #ui-datepicker-div").css("display", "none");
      $("body").append($("#ui-datepicker-div"));
    },
  });
}
